export const StockOperationTypes = [
    {
        id: 'NSOR',
        label: 'Com. Furnizor',
        labelEx: 'Comanda Furnizor',
        important: true
    },
    {
        id: 'NSRT',
        label: 'Ret. Furnizor',
        labelEx: 'Retur Comanda Furnizor'
    },
    {
        id: 'NUPR',
        label: 'Op. PF',
        labelEx: 'Operatie Persoana Fizica'
    },
    {
        id: 'NTRA',
        label: 'Op. Stocuri',
        labelEx: 'Operatie Stocuri (Transformare)'
    },
    {
        id: 'NPRE',
        label: 'Precomanda',
        labelEx: 'Precomanda'
    },
    {
        id: 'NEVT',
        label: 'Eveniment',
        labelEx: 'Eveniment'
    },
    {
        id: 'AUTO_EVT',
        label: 'Finalizare Eveniment',
        labelEx: 'Finalizare Eveniment (Automat)'
    },
    {
        id: 'NOTH',
        label: 'Alta',
        labelEx: 'Alt tip de operatie'
    },
    {
        id: 'TR_AUTO',
        label: 'AUTOTR',
        labelEx: 'Transfer Automat',
        important: true
    },
    {
        id: 'INV_TCG',
        label: 'INV TCG',
        labelEx: 'Inventariere TCG (CSV)',
        important: true
    },
    {
        id: 'AUTO_TRX',
        label: 'Transfer Inv.',
        labelEx: 'Transfer Inventar (Automat)',
        important: true
    }
]
